import React from 'react';
import SimplePage, { Card } from '../components/SimplePage';

const SERVICES = [
  {
    title: 'Threat Intelligence',
    points: [
      'Files: looked up on VirusTotal, which aggregates 70+ antivirus engines. Files VirusTotal hasn\'t seen are uploaded to it for analysis, and VirusTotal shares submissions with security researchers, so don\'t check private documents.',
      'Links: checked with Google Safe Browsing, PhishTank and VirusTotal.',
      'IP addresses: reputation from AbuseIPDB.',
      '"No threats found" means none of these services know of a problem. It isn\'t a guarantee.',
    ],
  },
  {
    title: 'Email Protection',
    points: [
      'Connect Gmail, Outlook or Yahoo with read-only access. We never delete or move your email.',
      'Links in incoming email are checked with Google Safe Browsing and attachments with VirusTotal.',
      'Flagged emails are listed for you to review.',
    ],
  },
  {
    title: 'Scam Check (iPhone app)',
    points: [
      'Paste a suspicious text or email to see common scam warning signs: unusual payment requests, pressure to act fast, requests for codes or passwords, impersonated brands and odd links.',
      'Links in the message are checked with Google Safe Browsing. The message text itself is analyzed on your phone.',
    ],
  },
  {
    title: 'Privacy Checkup (iPhone app)',
    points: [
      'A guided checklist of Apple\'s own privacy controls: Safety Check, camera, microphone and location access, location sharing, devices on your Apple Account, device-management profiles, Stolen Device Protection and more.',
      'Tips for checking a hotel room or rental for hidden cameras.',
      'iOS doesn\'t let any app scan an iPhone for spyware, so we guide you through Apple\'s tools instead.',
    ],
  },
  {
    title: 'Desktop Protection',
    points: [
      'A lightweight agent for Mac and Windows that reports system health and alerts you to command shells that download and run code, connections to ports often used by remote-access malware, and files renamed with known ransomware extensions.',
      'Alerts appear on the web dashboard and in the iPhone app.',
      'It isn\'t a full antivirus. Keep your computer\'s built-in protection turned on.',
    ],
    link: { href: '/download/', label: 'Install Desktop Protection' },
  },
];

const Services = () => (
  <SimplePage title="What CyberGuard Does" subtitle="Each feature, what it checks, and where the results come from">
    {SERVICES.map(service => (
      <Card key={service.title} title={service.title}>
        <ul className="list-disc pl-6 space-y-2">
          {service.points.map(point => <li key={point}>{point}</li>)}
        </ul>
        {service.link && (
          <p><a href={service.link.href} className="text-cyan-400 hover:underline">{service.link.label} →</a></p>
        )}
      </Card>
    ))}
  </SimplePage>
);

export default Services;
